import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { browserHistory } from 'react-router';
import { validateCompanyRepresentative, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm} from '../utils/utils.js';
import CompanyRepresentativeForm from '../components/CompanyRepresentativeForm.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        validateCompanyRepresentative(values, dispatch) {
            dispatch(submitForm())
            return dispatch(validateCompanyRepresentative(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError({ ...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.' });
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof (result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint)
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRepresentativeForm);



/** WEBPACK FOOTER **
 ** ./src/containers/CompanyRepresentativeFormContainer.js
 **/